import { useState } from "react";
import { UserRound, Save, Download, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCustomer } from "@/lib/customer";
import { DeleteAccountDialog } from "@/components/DeleteAccountDialog";

export const CustomerProfileCard = () => {
  const { customer, setCustomer } = useCustomer();
  const [f, setF] = useState({ name: customer?.name || "", phone: customer?.phone || "", marketing_consent: !!customer?.marketing_consent, notify_wins: customer?.notify_wins !== false, notify_reminders: customer?.notify_reminders !== false });
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      const c = await api.customerUpdate(f);
      setCustomer(c);
      setF({ name: c.name || "", phone: c.phone || "", marketing_consent: !!c.marketing_consent, notify_wins: c.notify_wins !== false, notify_reminders: c.notify_reminders !== false });
      toast.success("Profilo aggiornato");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };
  const download = async (fmt) => {
    try {
      const blob = await api.customerExport(fmt);
      const url = URL.createObjectURL(blob);
      const a = Object.assign(document.createElement("a"), { href: url, download: `i-miei-dati-viviwin.${fmt}` });
      a.click(); URL.revokeObjectURL(url);
    } catch { toast.error("Download non riuscito"); }
  };
  return (
    <Card className="p-5 bg-card border-border space-y-4" data-testid="customer-profile-card">
      <div className="flex items-center gap-2"><UserRound className="h-4 w-4 text-primary" /><h2 className="font-semibold">Il mio profilo</h2></div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="space-y-1.5"><Label>Email</Label><Input value={customer?.email || ""} disabled data-testid="profile-email" /></div>
        <div className="space-y-1.5"><Label htmlFor="profile-name">Nome</Label><Input id="profile-name" data-testid="profile-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Il tuo nome" /></div>
        <div className="space-y-1.5"><Label htmlFor="profile-phone">Telefono (WhatsApp)</Label><Input id="profile-phone" data-testid="profile-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="+39 333 1234567" /></div>
      </div>
      <div className="space-y-2">
        <p className="text-sm font-medium">Notifiche</p>
        {[["notify_wins", "Vincite", "Ricevuta via email quando vinci un premio"], ["notify_reminders", "Promemoria ritiro", "Avviso email/WhatsApp prima della scadenza del premio"], ["marketing_consent", "Promozioni", "Campagne e sconti via WhatsApp (consenso marketing)"]].map(([k, l, d]) => (
          <div key={k} className="flex items-center justify-between rounded-md border border-border px-3 py-2">
            <div><Label htmlFor={`profile-${k}`} className="text-sm">{l}</Label><p className="text-xs text-muted-foreground">{d}</p></div>
            <Switch id={`profile-${k}`} data-testid={k === "marketing_consent" ? "profile-consent" : `profile-${k}`} checked={f[k]} onCheckedChange={(v) => setF({ ...f, [k]: v })} />
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap gap-2">
          <Button data-testid="profile-save" onClick={save} disabled={saving} className="gap-2"><Save className="h-4 w-4" /> {saving ? "Salvataggio…" : "Salva profilo"}</Button>
          <Button data-testid="profile-export-json" variant="outline" className="gap-2 border-border" onClick={() => download("json")}><Download className="h-4 w-4" /> I miei dati (JSON)</Button>
          <Button data-testid="profile-export-xlsx" variant="outline" className="gap-2 border-border" onClick={() => download("xlsx")}><FileSpreadsheet className="h-4 w-4" /> I miei dati (Excel)</Button>
        </div>
        <DeleteAccountDialog />
      </div>
    </Card>
  );
};
